import React from 'react';
import List from './List';
import Form from './Form';
import axios from 'axios';
import './App.css';


/**
 * 投稿データを取得するAPIのパスを定義
 * @type {string}
 * */
// const URL = "/comments/friend?sort=desc";
const URL = "/friend.json";

/**
 * App Class Component
 * 
 * @class App
 * @extends {React.Component}
 */
class App extends React.Component {

  /**
   * Creates an instance of App.
   * 
   * @param {*} props
   * @memberof App
   */
  constructor(props) {
    console.log('@App.js___constructor----->');

    super(props);

    /**
     * Creates an instance of App.
     * 
     * @param {*} props
     * @memberof App
     */
    this.state = {
      posts: [],
      views: [],
      currentPage: 1,
      postsPerPage: 10,
      total: 0,
      offset: 0,
      viewState: 'LOADING'
    };
  }// end constructor


  /**
   * ComponentがMountされた後に実行されるメソッド(renderメソッドによるDOM挿入直後)。
   * Ajaxを使ったデータフェッチなどの処理を記述。
   * @memberof App
   */
  componentDidMount() {
    console.log("@App.js___componentDidMount------->");

    axios.get(URL).then(res => {
      console.log("@App.js___componentDidMount_axios_success------->");

      if(res.data.existsFile === 'none') {
        this.setState({
          viewState: 'EMPTY'
        });
      }else{
        this.setState({
          posts: res.data,
          views: res.data.slice(0, 10),
          total: Math.ceil(res.data.length/10),
          viewState: 'READY'
        });
      }

    }).catch(error => {
      console.log("@App.js___componentDidMount_axios_failure------->", error);

      this.setState({
        viewState: 'ERROR'
      })
    });
  }// end componentDidMount


  /**
   * 親フレームへ高さ情報を送信。
   * @memberof App
   */  
  componentDidUpdate() {
    console.log("@App.js___componentDidUpdate------->");

    let h = document.documentElement.scrollHeight;
    window.parent.postMessage(h, "*");
  }


  /**
   * フォームで入力した投稿を最初に取得した投稿一覧に追加するメソッド。
   * 関数コンポーネントFormに本メソッドを渡す。
   * 
   * @param {*} post Formコンポーネントで入力した投稿データ
   * @memberof App
   */
  onSubmitPost(post) {
    console.log("@App.js___onSubmitPost------->", post);

    // state内の投稿一覧にFormで入力した投稿データを加え投稿リストの初期値をリセット
    let tmp = [post, ...this.state.posts];
    this.setState({
      posts: tmp,
      views: tmp.slice(0, 10),
      currentPage: 1,
      offset: 0,
    });
  }// end onSubmitPost


  /**
   * 投稿リストの状態を設定するメソッド。
   * 関数コンポーネントListに本メソッドを渡して投稿リストに表示する内容を処理する。
   * 
   * @param {*} state 投稿リストに表示するデータや現在のページ番号などの状態
   * @memberof App
   */
  onSubmitViews(state) {
    console.log("@App.js___onSubmitViews----->");
    this.setState({
      views: state.views,
      currentPage: state.currentPage,
      offset: state.offset
    });
  }


  /**
   * 画面の処理ステータスを設定するメソッド。
   * 関数コンポーネントFormに本メソッドを渡す。
   *
   * @param {*} status 画面処理ステータス(ERROR, EMPTY, LOADING, READY)
   * @memberof App
   */
  setViewState(status) {
    console.log("@App.js___setViewState------->");
    this.setState({viewState: status});
  }
  

  /**
   * 画面処理ステータスに応じて表示する内容を切り替えるメソッド。
   * 投稿データの取得に成功した場合はListコンポーネントを表示する。
   * renderメソッド内で使用。
   *
   * @param {*} status 画面処理ステータス(ERROR, EMPTY, LOADING, READY)
   * @return {*} 投稿リスト
   * @memberof App
   */
  renderSwitch(status) {
    switch(status) {
      case 'ERROR':
        return (<div>エラーが発生しました。時間をおいて再度ページをリロードしてください。</div>);
      case 'EMPTY':
        return (<div>投稿はありません。</div>);
      case 'LOADING':
          return (<div className='loader'>Now Loading</div>);
      default:
        return (
          <List
            state={this.state}
            onSubmitViews={(state) => this.onSubmitViews(state)}
          />
        );
    }
  }


  /**
   * render method
   *
   * @return {*} JSX
   * @memberof App
   */
  render() {
    console.log("@App.js___render----->");

    return (
      <div className="App">
        <Form
          state={this.state}
          setViewState={(status) => this.setViewState(status)}
          onSubmitPost={(post) => this.onSubmitPost(post)}
        />
        <hr />
        {this.renderSwitch(this.state.viewState)}
      </div>
    );
  }// end render

}// end App Class Component

export default App;
